<template>
  <InputNumberBaseAntd
    :class="['tw:w-full', { 'addon-after-class': attrs['addon-after'], 'unit-class': attrs.unit }]"
    v-bind="attrs"
    :borderless="true"
    size="middle"
    :precision="precision"
  >
    <template v-for="(comp, name) in slots" :key="name" v-slot:[name]>
      <component :is="comp" />
    </template>
  </InputNumberBaseAntd>
  <span v-if="attrs.unit" class="mars-unit">{{ attrs.unit }}</span>
</template>
<script lang="ts">
import { useAttrs, useSlots, defineComponent, computed } from 'vue'
import InputNumberBaseAntd from '@/components/base/antd/InputNumberBaseAntd.vue'

export default defineComponent({
  name: 'mars-input-number',
  inheritAttrs: false,
  components: {
    InputNumberBaseAntd,
  },
  setup() {
    const attrs = useAttrs()
    const slots = useSlots()

    // 在style.js中配置 toFixed 用于控制保留小数位数
    const precision = computed(() => attrs.tofixed as number | undefined)

    return {
      slots,
      attrs,
      precision,
    }
  },
})
</script>
